export { formatINR, formatNumber } from "src/features/analytics/constants"

export const AGING_BUCKETS = [
  { key: "current", label: "Not due", color: "#64748b" },
  { key: "0_30", label: "0–30 days", color: "#10b981" },
  { key: "31_60", label: "31–60 days", color: "#f59e0b" },
  { key: "61_90", label: "61–90 days", color: "#f97316" },
  { key: "90_plus", label: "90+ days", color: "#ef4444" },
]

export const DAYS_OVERDUE_STYLE = {
  ok: { cls: "bg-emerald-50 text-emerald-700 border-emerald-200", label: "On time" },
  warning: { cls: "bg-amber-50 text-amber-700 border-amber-200" },
  danger: { cls: "bg-red-50 text-red-700 border-red-200" },
  critical: { cls: "bg-red-100 text-red-800 border-red-300" },
}

export function daysOverdueVariant(days) {
  if (days <= 0) return "ok"
  if (days <= 30) return "warning"
  if (days <= 60) return "danger"
  return "critical"
}

export const OFFSET_LABELS = {
  "T-7": "7 days before",
  "T-3": "3 days before",
  due: "On due date",
  "T+3": "3 days after",
  "T+7": "7 days after",
}

export const REMINDER_CHANNELS = [
  { value: "email", label: "Email" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "sms", label: "SMS" },
]
